/**
 * Created by Vladislav
 */

cleverapps.FlexBox = cc.Node.extend({
    ctor: function (children, options) {
        this._super();

        this.options = options || {};

        this.setAnchorPoint(0.5, 0.5);

        if (children && children.length) {
            this.setItems(children);
        }
    },

    setItems: function (items, cleanup) {
        this.removeAllChildren(cleanup);

        this.descriptors = items.filter(Boolean).map((item) => {
            if (item instanceof cc.Node) {
                return { item };
            }
            return item;
        });

        this.descriptors.forEach((desc) => {
            this.addChild(desc.item);
        });

        this.reshape();
    },

    reshape: function () {
        if (!this.descriptors || !this.descriptors.length) {
            this.setContentSize(0, 0);
            return this;
        }

        const { options } = this;
        const isHorizontal = options.direction === undefined || options.direction === cleverapps.UI.HORIZONTAL;
        const margin = options.margin || 0;

        const isVisible = (node) => {
            if (!node.visible) {
                return false;
            }

            if (node instanceof cleverapps.Layout || node instanceof cleverapps.FlexBox) {
                return node.children.some(isVisible);
            }

            return true;
        };
        const descs = this.descriptors.filter((desc) => isVisible(desc.item));

        let staticSize = 0;
        let totalFlexUnits = 0;

        descs.forEach((desc) => {
            if (desc.flex) {
                totalFlexUnits += desc.flex;
            } else {
                const scale = isHorizontal
                    ? (desc.item.baseScaleX || desc.item.baseScale || desc.item.scaleX)
                    : (desc.item.baseScaleY || desc.item.baseScale || desc.item.scaleY);
                staticSize += isHorizontal
                    ? desc.item.width * Math.abs(scale)
                    : desc.item.height * Math.abs(scale);
            }
        });

        let crossSize = 0;
        descs.forEach((desc) => {
            const scale = isHorizontal
                ? (desc.item.baseScaleY || desc.item.baseScale || desc.item.scaleY)
                : (desc.item.baseScaleX || desc.item.baseScale || desc.item.scaleX);
            crossSize = Math.max(crossSize, (isHorizontal ? desc.item.height : desc.item.width) * Math.abs(scale));
        });
        crossSize = (isHorizontal ? options.height : options.width) || crossSize;

        const totalFixed = isHorizontal ? (options.width || 0) : (options.height || 0);
        const remaining = Math.max(0, totalFixed - staticSize - margin * (descs.length - 1));

        if (totalFlexUnits > 0) {
            descs.forEach((desc) => {
                if (desc.flex) {
                    const allocated = remaining * desc.flex / totalFlexUnits;
                    if (isHorizontal) {
                        this._resizeFlexItem(desc.item, allocated, crossSize);
                    } else {
                        this._resizeFlexItem(desc.item, crossSize, allocated);
                    }
                }
            });
        }

        let pos = 0;
        const ordered = isHorizontal ? descs : descs.slice().reverse();
        ordered.forEach((desc) => {
            const scaleX = desc.item.baseScaleX || desc.item.baseScale || desc.item.scaleX;
            const scaleY = desc.item.baseScaleY || desc.item.baseScale || desc.item.scaleY;
            const size = isHorizontal ? desc.item.width * Math.abs(scaleX) : desc.item.height * Math.abs(scaleY);
            const slot = desc.flex ? remaining * desc.flex / totalFlexUnits : size;

            if (isHorizontal) {
                desc.item.setPosition(pos + (slot - size) / 2 + size * desc.item.anchorX, crossSize * desc.item.anchorY);
            } else {
                desc.item.setPosition(crossSize * desc.item.anchorX, pos + (slot - size) / 2 + size * desc.item.anchorY);
            }
            pos += slot + margin;
        });

        this.setContentSize2(
            isHorizontal ? (options.width || 0) : crossSize,
            isHorizontal ? crossSize : (options.height || 0)
        );

        if (options.padding) {
            cleverapps.UI.wrapWithPadding(this, options.padding, true);
        }

        return this;
    },

    _resizeFlexItem: function (item, width, height) {
        if (item instanceof cleverapps.UI.LabelTTF || item instanceof cleverapps.UI.ImageFont) {
            item.setDimensions(width, 0);
            item.fitTo(undefined, height);
        } else if (item.fitTo) {
            item.fitTo(width, height);
        } else {
            cleverapps.UI.fitToBox(item, { width, height });
        }
    },

    setOptions: function (options) {
        cleverapps.override(this.options, options);
        this.reshape();
    }
});
